/**
 * Minimum number of consecutive empty paragraphs that is treated as editor bloat.
 * Must stay in sync with the SQL cleanup script and the API normalization.
 */
const EMPTY_PARAGRAPH_RUN_THRESHOLD = 20

/**
 * Matches a run of EMPTY_PARAGRAPH_RUN_THRESHOLD or more consecutive empty paragraphs
 * (<p></p> or <p><br></p>, in any mix).
 */
const EMPTY_PARAGRAPH_RUN_PATTERN = new RegExp(`(?:<p>(?:<br\\s*\\/?>)?<\\/p>){${EMPTY_PARAGRAPH_RUN_THRESHOLD},}`, "gi")

const SINGLE_EMPTY_PARAGRAPH = "<p><br></p>"

/**
 * Collapses runs of EMPTY_PARAGRAPH_RUN_THRESHOLD or more consecutive empty paragraphs into a
 * single <p><br></p>. Shorter runs and all other content are left untouched.
 * @param html - Rich-text HTML produced by the editor
 * @returns The normalized HTML
 */
export function collapseEmptyParagraphs(html: string): string {
	if (!html) {
		return html
	}
	return html.replace(EMPTY_PARAGRAPH_RUN_PATTERN, SINGLE_EMPTY_PARAGRAPH)
}
